import { OnInit } from "@angular/core";

/**
 * Clase que representa el usuario activo en el portal de la siguiente manera:
 * 
 * jti => `tercId` - Id del tercero\
 * sub => `email` - Email del tercero\
 * iss => `nombreCompleto` - Nombre completo del tercero\
 * role => `rol` - rol del tercero en la plataforma\
 * exp => `date` - Fecha de expiracion del token\
 * iat => `date` - Fecha de creacion del token
 * 
 * @author Frank Edward Daza Gonzalez
 * @version Nov 08, 2018
 * @since 6.2.4
 * @see io.jsonwebtoken.JwtBuilder on Java Doc Source.
 */
export class UserSession {

  jti: number;
  sub: string;
  iss: string;
  role: string;
  iat: number;
  exp: number;

  constructor() {}

}
